<div class="toast-container">
  @for (toast of toastService.toasts(); track toast.id) {
    <div
      class="toast"
      [@toastSlide]
      [class.success]="toast.type === 'success'"
      [class.error]="toast.type === 'error'"
    >
      {{ toast.msg }}
    </div>
  }
</div>
